<script>
  export default {
    props: {
      overlayData: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<template>
  <div
    class="
      @1024/layout/justify:start
      layout/flex
      layout/justify:center
    ">
    <div
      class="
        @1024/layout/width
        layout/height
        layout/margin:top:page
        layout/ratio:3:2
        layout/width:100%
      "
      style="
        --layout--height: auto;
        --1024--layout--width: 36.3rem;
      "
      >
      <picture class="picture">
        <img
          class="picture/image:crop"
          :src="overlayData.imageURL"
          :alt="overlayData.title"
        />
      </picture>
    </div>
  </div>
</template>